import React, {useEffect, useState, useRef, useCallback} from 'react'
import {Col, Row} from "react-bootstrap";
import HeaderContainer from "../BetaPage/HeaderContainer";
import PrimaryContainer from "./PrimaryContainer";
import PrimaryContainerWithHeight from "./PrimaryContainerWithHeight";
import Order from './PrimaryRow/Order';
import Range from './PrimaryRow/Range';
import Export from "./PrimaryRow/Export";
import Company from "./AddressRow/Company";
import WorkInstruction from "./WorkInstruction";
import {getCustomization, getOrder, getOrderChart, getOrderTable} from "./actions/detailsPageActions";
import {connect} from "react-redux";
import ChartContainer from "../BetaPage/ChartContainerComponent";
import styled from "styled-components";
import TotalTable from "./TotalTable";
import HoursTable from "./HoursTable";
import Details from "./PrimaryRow/Details";
import DetailedPartTable from "./DetailedPartTable";
import DailyPartTable from "./DailyPartTable";
import PrimaryRowContainer from "./PrimaryRow/PrimaryRowContainer";
import AddressRowContainer from "./AddressRow/AddressRowContainer";
import {MainSpinnerContainer} from "../MainSpinnerContainer";
import ViewCustomizerSidebar from "./ViewCustomizerSidebar";
import ChartNOK from "./Charts/ChartNOK";
import ChartRework from "./Charts/ChartRework";
import ChartNOKDay from "./Charts/ChartNOKDay";
import ChartTotalCheckedPartsDay from "./Charts/ChartTotalCheckedPartsDay";
import ChartOKNOK from "./Charts/ChartOKNOK";
import ChartOKNOKRework from "./Charts/ChartOKNOKRework";
import ChartPareto from "./Charts/ChartPareto";
import ChartHours from "./Charts/ChartHours";
import {chartColorsNOKDay} from "./Charts/chartColors";
import {downloadFullPagePDF} from "./pdfExporter";
import ChartDownloadWrapper from "./ChartDownloadWrapper";
import ChartFullscreenWrapper from './ChartFullscreenWrapper';
import ChartDefects from "./Charts/ChartDefects";
import {userHasPermissionSelector} from "../../../selectors/authSelectors";
import {PERMISSION_EDIT_CUSTOMER_DASHBOARD, PERMISSION_CLIENT_PANEL} from "../../../../../common/src/permissions";

const LeftChartCol = styled(Col)`
    @media (min-width: 992px) {
        padding-left: 10px;
        padding-top: 20px;
    }
    padding-right: 5px;
`;

const RightChartCol = styled(Col)`
    @media (min-width: 992px) {
        padding-right: 10px;
        padding-top: 20px;
        padding-left: 6px;
    }
    @media (max-width: 991px) {
        padding-top: 40px;
    }
`;

const CustomRow = styled(Row)`
    margin-left: auto;
    margin-right: 12px;
    padding-top: 15px;
`;

function DetailsPage({
                         history,
                         match,
                         getOrderData,
                         getCustomization,
                         getOrderChartData,
                         getOrderTableData,
                         workingHoursData,
                         customerCompany,
                         locationCompany,
                         chartData,
                         range,
                         tableData,
                         chartCustomizerData,
                         customizerData,
                         selectedParts,
                         user,
                         dashboardDataLoaded,
                         orderNumber,
                         orderName,
                         orderId,
                         canShowCreateViewForCustomer,
                         clientPanelPermission
                     }) {
    const [nokRangeGraph, setNokRangeGraph] = useState("week");
    const [reworkedRangeGraph, setReworkedRangeGraph] = useState("week");
    const [partsCheckedRangeGraph, setPartsCheckedRangeGraph] = useState("week");
    const [height, setHeight] = useState(440);
    const [rangeArray, setRangeArray] = useState(["week", "month", "year"]);
    const [isLoading, setIsLoading] = useState(false);
    const [width, setWidth] = useState(8);
    const [sortedCustomizerData, setSortedCustomizerData] = useState([]);
    const [lastParam, setLastParam] = useState('');
    const [customerId, setCustomerId] = useState('');

    useEffect(() => {
        const pathname = window.location.pathname;
        const segments = pathname.split('/').filter(segment => segment !== '');
        const last = segments[segments.length - 1] || '';
        setLastParam(last);
        const customerId = segments[segments.length - 4] || "";
        setCustomerId(customerId);
    }, []);

    // 🔑 TRACKER: Śledzenie jakie ID i range już pobrano
    const requestTrackerRef = useRef({
        lastOrderId: null,
        lastRangeStart: null,
        lastRangeEnd: null,
        partsChanged: null
    });
    // ================================================================
    // ✅ EFFECT 1: Inicjalizacja (user)
    // ================================================================
    useEffect(() => {
        window.scrollTo(0, 0);

        if (match.params.id && user) {
            if (history.location.pathname.includes('/simulation')) {
                getOrderData(match.params.id);
                const regex = history.location.pathname.match(/\/customer\/([^\/]+)\/dashboard/);
                const employeeId = regex ? regex[1] : null;
                getCustomization(match.params.id, employeeId);
            } else if (user.employeesId) {
                getOrderData(match.params.id);
                getCustomization(match.params.id, user.employeesId[0]);
            }
        }
    }, [user, match.params.id]);

    // ================================================================
    // ✅ EFFECT 2: Pobieranie danych (charts + table) - DEDYKOWANY
    // ================================================================
    useEffect(() => {
        const orderId = match.params.id;
        const rangeStart = range?.start;
        const rangeEnd = range?.end;
        // Warunki do pobrania - MUSZĄ być spełnione
        if (!orderId || !dashboardDataLoaded || !rangeStart || !rangeEnd) {
            return;
        }

        // 🔑 DEDUPLIKACJA: Sprawdź czy to są NEW dane (zmienił się ID lub range)
        const tracker = requestTrackerRef.current;
        const orderIdChanged = tracker.lastOrderId !== orderId;
        const rangeChanged = tracker.lastRangeStart !== rangeStart || tracker.lastRangeEnd !== rangeEnd;
        const partsChanged = tracker.selectedParts !== selectedParts;
        // Pobierz TYLKO jeśli:
        // 1. To pierwsze pobranie (lastOrderId === null)
        // 2. LUB zmienił się ID
        // 3. LUB zmienił się range
        // 4. LUB zmieniły się wybrane części
        if (tracker.lastOrderId !== null && !orderIdChanged && !rangeChanged && !partsChanged) {
            return;
        }

        // ✅ Pobranie danych - TYLKO RAZ dla kombinacji ID + range
        getOrderChartData(orderId);
        getOrderTableData(orderId);

        // Zaktualizuj tracker
        tracker.lastOrderId = orderId;
        tracker.lastRangeStart = rangeStart;
        tracker.lastRangeEnd = rangeEnd;
        tracker.selectedParts = selectedParts;
    }, [dashboardDataLoaded, match.params.id, range, selectedParts]);

    // ================================================================
    // ✅ EFFECT 3: Sortowanie customizerData
    // ================================================================
    useEffect(() => {
        setSortedCustomizerData(customizerData
            ? [...customizerData].sort((a, b) => {
                const keyA = parseInt(a.key) || 0;
                const keyB = parseInt(b.key) || 0;
                return keyA - keyB;
            })
            : customizerData);
    }, [customizerData]);

    // ================================================================
    // ✅ EFFECT 4: Ustaw szerokość
    // ================================================================
    useEffect(() => {
        setWidth(((sortedCustomizerData && sortedCustomizerData[4] && sortedCustomizerData[4].enabled === false) || selectedParts.length !== 0) ? 12 : 8)
    }, [sortedCustomizerData, selectedParts]);

    // ================================================================
    // Reszta effectów
    // ================================================================

    useEffect(() => {
        document.getElementById("container").scrollIntoView({ block: 'start', behavior: 'smooth' });
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 1800);
    }, []);

    useEffect(() => {
        if (tableData.generalSummaryPerPart && tableData.generalSummaryPerPart.rows) {
            let result = 220 + tableData.generalSummaryPerPart.rows.length * 40
            setHeight(result < 440 ? 440 : result)
        }
    }, [tableData])

    // ================================================================
    // ✅ CALLBACK: Zamknięcie fullscreena - pobranie świeżych danych
    // ================================================================
    const handleCloseFullscreen = useCallback(() => {
        // Pobrań świeże dane dla wszystkich chartów i tabel
        getOrderChartData(match.params.id);
        getOrderTableData(match.params.id);
    }, [match.params.id, getOrderChartData, getOrderTableData]);

    let setPartsCheckedRangeGraphFunction = () => {
        setPartsCheckedRangeGraph(rangeArray[(rangeArray.findIndex(el => el === partsCheckedRangeGraph) + 1) % rangeArray.length]);
    }

    let setNokGraphFunction = () => {
        setNokRangeGraph(rangeArray[(rangeArray.findIndex(el => el === nokRangeGraph) + 1) % rangeArray.length])
    }
    let setReworkedGraphFunction = () => {
        setReworkedRangeGraph(rangeArray[(rangeArray.findIndex(el => el === reworkedRangeGraph) + 1) % rangeArray.length])
    }

    const formatDateRange = (range) => {
        if (!range || !range.start || !range.end) {
            return '';
        }

        // Konwertuj ISO strings na Date obiekty
        const startDate = new Date(range.start);
        const endDate = new Date(range.end);

        // Dodaj jeden dzień
        startDate.setDate(startDate.getDate() );
        endDate.setDate(endDate.getDate() );

        // Formatuj: DD/MM/YYYY
        const formatDate = (date) => {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    };
    const handleDownloadPDF = async () => {
        await downloadFullPagePDF('RES-quality-report', orderName);
    };
    return (
        <div id="container">
            {isLoading && (<MainSpinnerContainer />)}
            <div style={{fontSize: 16, backgroundColor: "rgb(240, 242, 245)"}}>
                <Row style={{marginLeft: "auto", marginRight: "auto"}}>
                    <Col xs={12} style={{paddingLeft: 32}}>
                        <HeaderContainer title="REPORT"/>
                    </Col>
                </Row>
                <Row style={{marginLeft: "auto", marginRight: 12}}>
                    <Col xs={12} sm={6} lg={3} style={{padding: "0 0 15px"}}>
                        <PrimaryRowContainer icon="inbox" subtitle="Order" mode="1" height={"175px"}>
                            <Order />
                        </PrimaryRowContainer>
                    </Col>
                    <Col xs={12} sm={6} lg={3} style={{padding: "0 0 15px"}}>
                        <PrimaryRowContainer icon="check" subtitle="Details" mode="2" height={"175px"}>
                            <Details />
                        </PrimaryRowContainer>
                    </Col>
                    <Col xs={12} sm={6} lg={3} style={{padding: "0 0 15px"}}>
                        <PrimaryRowContainer icon="time" subtitle="Range" mode="3" padding="3px" height={"175px"}>
                            <Range />
                        </PrimaryRowContainer>
                    </Col>
                    <Col xs={12} sm={6} lg={3} style={{padding: "0 0 15px"}}>
                        <PrimaryRowContainer icon="download-alt" subtitle="Export" mode="4" height={"175px"}>
                            <Export orderId={match.params.id} onRightClick={handleDownloadPDF}>
                                Download charts as PDF
                            </Export>
                        </PrimaryRowContainer>
                    </Col>
                </Row>
                {/*<WorkInstruction />*/}
                <CustomRow>
                    <Col xs={12} sm={6} md={6} style={{padding: "0 0 40px", height: 255}}>
                        <AddressRowContainer subtitle="Company" mode="2" icon="envelope">
                            <Company company={customerCompany}/>
                        </AddressRowContainer>
                    </Col>
                    <Col xs={12} sm={6} md={6} style={{padding: "0 0 40px", height: 255}}>
                        <AddressRowContainer subtitle="Location" mode="2" icon="envelope">
                            <Company company={locationCompany} />
                        </AddressRowContainer>
                    </Col>
                </CustomRow>
                <Row style={{marginLeft: "auto", paddingTop: 10, marginRight: 8}}>
                    {sortedCustomizerData && sortedCustomizerData[0] && sortedCustomizerData[0].enabled && (
                        <Col xs={12} md={4}>
                            <ChartContainer title="Parts checked" mode="1" data={chartData.partCheckedGraph} clickFunction={setPartsCheckedRangeGraphFunction} range={partsCheckedRangeGraph} rangeCount={rangeArray.length} />
                        </Col>
                    )}
                    {sortedCustomizerData && sortedCustomizerData[1] && sortedCustomizerData[1].enabled && (
                        <Col xs={12} md={4}>
                            <ChartContainer title="NOK" textColor="red" mode="3" data={chartData.NOKGraph} clickFunction={setNokGraphFunction} newValue={1} range={nokRangeGraph} rangeCount={rangeArray.length} />
                        </Col>
                    )}
                    {sortedCustomizerData && sortedCustomizerData[2] && sortedCustomizerData[2].enabled && (
                        <Col xs={12} md={4}>
                            <ChartContainer title="Reworked" textColor="darkorange" mode="3" data={chartData.reworkedGraph} clickFunction={setReworkedGraphFunction} newValue={0} range={reworkedRangeGraph}  rangeCount={rangeArray.length} />
                        </Col>
                    )}
                </Row>
                <Row style={{marginLeft: "auto", marginRight: 12, paddingTop: 20}}>
                    {sortedCustomizerData && sortedCustomizerData[3] && sortedCustomizerData[3].enabled && (
                        <Col xs={12} sm={width} md={width} style={{padding: 0}}>
                            <PrimaryContainerWithHeight subtitle="Total" mode="2" height={`${height}px`} icon="th-list">
                                <TotalTable />
                            </PrimaryContainerWithHeight>
                        </Col>)}
                    {selectedParts.length === 0 && sortedCustomizerData && sortedCustomizerData[4] && sortedCustomizerData[4].enabled && (
                        <Col xs={12} sm={4} md={4} style={{padding: 0}}>
                            <PrimaryContainerWithHeight subtitle="Hours" mode="2" height={`${height}px`} icon="hourglass" paddingLeft={"30px"}>
                                <div style={{display: "inline-flex", paddingLeft: 2}}><HoursTable /></div>
                            </PrimaryContainerWithHeight>
                        </Col>)}
                </Row>
                <Row style={{ marginRight: 0, paddingTop: 35}}>
                    {sortedCustomizerData && sortedCustomizerData[5] && sortedCustomizerData[5].enabled && (
                        <Col xs={12}>
                            <PrimaryContainer subtitle="Divided" mode="2" height={`auto`} icon="th">
                                <DetailedPartTable />
                            </PrimaryContainer>
                        </Col>)}
                </Row>
                <Row style={{marginRight: 0, paddingTop: 0}}>
                    {sortedCustomizerData && sortedCustomizerData[6] && sortedCustomizerData[6].enabled && (
                        <Col xs={12}>
                            <PrimaryContainer subtitle="Detailed" mode="2" height={`auto`} icon="calendar">
                                <DailyPartTable />
                            </PrimaryContainer>
                        </Col>)}
                </Row>
                <Row style={{marginLeft: 0, marginRight: 0, paddingTop: 0}}>
                    {sortedCustomizerData && sortedCustomizerData[7] && sortedCustomizerData[7].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="NOK" scale={false} onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-nok" officialOrderName={orderName}>
                                    {/*1*/}
                                    <ChartNOK title={"NOK"} subtitle={"Total"} data={chartCustomizerData.chartNOKData} analysisDays={chartCustomizerData.analysisDays} detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[8] && sortedCustomizerData[8].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Rework" scale={false} onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-rework" officialOrderName={orderName}>
                                    {/*2*/}
                                    <ChartRework title={"Rework"} subtitle={"Total"} data={chartCustomizerData.chartReworkedData} analysisDays={chartCustomizerData.analysisDays} detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[9] && sortedCustomizerData[9].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="NOK" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-nok-daily" officialOrderName={orderName} type="bar">
                                    {/*3*/}
                                    <ChartNOKDay title={"NOK"} subtitle={"Daily Analysis"} data={chartCustomizerData.chartNOKDayData} detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[10] && sortedCustomizerData[10].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Rework" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-rework-daily" officialOrderName={orderName} type="bar">
                                    {/*4*/}
                                    <ChartNOKDay title={"Rework"} subtitle={"Daily Analysis"} data={chartCustomizerData.chartReworkDayData} chartColors={chartColorsNOKDay} detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[19] && sortedCustomizerData[19].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Defects / NOK" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-rework-daily" officialOrderName={orderName} type="bar">
                                    {/*5*/}
                                    <ChartDefects title={"Defects / NOK"} subtitle={"Daily Analysis"} data={chartCustomizerData.chartNOKDayData} chartColors={chartColorsNOKDay} detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[11] && sortedCustomizerData[11].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Parts Checked" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-parts-checked" officialOrderName={orderName} type="bar">
                                    {/*6*/}
                                    <ChartTotalCheckedPartsDay title={"Parts Checked"} subtitle={"Daily Analysis"} data={chartCustomizerData.chartTotalCheckedPartDayData} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[12] && sortedCustomizerData[12].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Quality Control Summary NOK/OK" scale={false} onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-quality-control-nok" officialOrderName={orderName}>
                                    {/*7*/}
                                    <ChartOKNOK title={"Quality Control Summary NOK/OK"} subtitle={"Total"} data={chartCustomizerData.chartOKNOKData} detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[13] && sortedCustomizerData[13].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Quality Control Summary" scale={false} onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-quality-control" officialOrderName={orderName}>
                                    {/*8*/}
                                    <ChartOKNOKRework title={"Quality Control Summary"} subtitle={"Total"} data={chartCustomizerData.chartOKReworkData} detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[14] && sortedCustomizerData[14].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Pareto Defects" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-pareto-defects" officialOrderName={orderName} type="bar">
                                    {/*9*/}
                                    <ChartPareto title={"Pareto Defects"} subtitle={"Total"} data={chartCustomizerData.chartParetoNOKData} dataColor="red" lineColor="blue" detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)} customizationKey="14" orderName={orderName} orderId={match.params.id} customerId={customerId} lastParam={lastParam}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[15] && sortedCustomizerData[15].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Pareto Reworked" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-pareto-rework" officialOrderName={orderName} type="bar">
                                    {/*10*/}
                                    <ChartPareto title={"Pareto Reworked"} subtitle={"Total"} data={chartCustomizerData.chartParetoReworkedData}  dataColor="#E07A00" lineColor="blue" detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)} customizationKey="15" orderName={orderName} orderId={match.params.id} customerId={customerId} lastParam={lastParam}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[16] && sortedCustomizerData[16].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Pareto NOK&Reworked" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-pareto-nok-reworked" officialOrderName={orderName} type="bar">
                                    {/*11*/}
                                    <ChartPareto title={"Pareto NOK&Reworked"} subtitle={"Total"} data={chartCustomizerData.chartParetoNOKandReworkedData} dataColor="rgb(255, 69, 0)" lineColor="blue" detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)} customizationKey="16" orderName={orderName} orderId={match.params.id} customerId={customerId} lastParam={lastParam}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[17] && sortedCustomizerData[17].enabled && (
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Pareto Part NOK&Reworked" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-pareto-part-nok-reworked" officialOrderName={orderName} type="bar">
                                    {/*12*/}
                                    <ChartPareto title={"Pareto Part NOK&Reworked"} subtitle={"Total"} data={chartCustomizerData.chartParetoPartReworkNOKData} dataColor="rgb(255, 69, 0)" lineColor="blue" detailsDesc={tableData.letterColumnsDescription} orderNumber={orderNumber} dateRange={formatDateRange(range)} customizationKey="17" orderName={orderName} orderId={match.params.id} customerId={customerId} lastParam={lastParam}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>)}
                    {sortedCustomizerData && sortedCustomizerData[18] && sortedCustomizerData[18].enabled && sortedCustomizerData[4].show && ( //show only if customer can view HoursTable
                        <Col xs={12} md={4}>
                            <ChartFullscreenWrapper chartTitle="Working Hours" onClose={handleCloseFullscreen}>
                                <ChartDownloadWrapper chartId="chart-working-hours" officialOrderName={orderName} type="bar">
                                    {/*13*/}
                                    <ChartHours title={"Working Hours"} subtitle={"Total"} data={chartCustomizerData.chartHoursData} orderNumber={orderNumber} dateRange={formatDateRange(range)}/>
                                </ChartDownloadWrapper>
                            </ChartFullscreenWrapper>
                        </Col>
                    )}
                </Row>
            </div>
            {(canShowCreateViewForCustomer || clientPanelPermission) && <ViewCustomizerSidebar />}
        </div>
    )
}
function mapDispatchToProps() {
    return dispatch => ({
        getOrderData: (id) => dispatch(getOrder(id)),
        getCustomization: (id, employeeId) => dispatch(getCustomization(id, employeeId)),
        getOrderChartData: (id) => dispatch(getOrderChart(id)),
        getOrderTableData: (id) => dispatch(getOrderTable(id))
    })
}

const mapStateToProps = state => {
    let {clientPanel, auth} = state;
    return {
        ...clientPanel.detailsPageReducer.data,
        range: clientPanel.detailsPageReducer.range,
        chartData: clientPanel.detailsPageReducer.chartData,
        tableData: clientPanel.detailsPageReducer.tableData,
        chartCustomizerData: clientPanel.detailsPageReducer.chartCustomizerData,
        customizerData: clientPanel.detailsPageReducer.customizations,
        selectedParts: clientPanel.detailsPageReducer.selectedParts,
        dashboardDataLoaded: clientPanel.detailsPageReducer.dashboardDataLoaded,
        user: auth.user,
        canShowCreateViewForCustomer: userHasPermissionSelector(state, PERMISSION_EDIT_CUSTOMER_DASHBOARD),
        clientPanelPermission: userHasPermissionSelector(state, PERMISSION_CLIENT_PANEL),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailsPage);